import React, { ElementType, ForwardedRef } from "react";
import { ButtonVariants, ButtonTypes } from "../../shared/Button";
import { baseButtonStyles, buttonRecipe, linkStyles } from "../../shared/Button/Button.style";
import { cx } from "../../../styled-system/css";

interface ButtonProps {
  onClick?: React.MouseEventHandler;
  onMouseDown?: React.MouseEventHandler;
  onKeyUp?: React.KeyboardEventHandler<HTMLAnchorElement>;
  type?: ButtonTypes;
  disabled?: boolean;
  variant?: ButtonVariants;
  testSelector?: string;
  element?: ElementType;
  inSlider?: boolean;
  activeSlide?: boolean;
  ariaLabel?: string;
  ariaExpanded?: boolean | "true" | "false";
  ariaControls?: string;
  className?: string;
  ref?: ForwardedRef<HTMLButtonElement>;
  children?: React.ReactNode;
}

export const Button = (props: ButtonProps) => {
  const {
    onClick,
    onMouseDown,
    onKeyUp,
    type = "button",
    disabled,
    variant = ButtonVariants.Standard,
    testSelector,
    element,
    children,
    inSlider = false,
    activeSlide = false,
    ariaLabel,
    ariaExpanded,
    ariaControls,
    className,
    ref,
  } = props;

  const Component = element || "button";
  const getSliderTabIndex = () => (activeSlide ? 0 : -1);

  return (
    <Component
      onClick={onClick}
      onMouseDown={onMouseDown}
      onKeyUp={onKeyUp}
      data-testid={testSelector}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      className={cx(
        variant === ButtonVariants.Text ? linkStyles : cx(baseButtonStyles, buttonRecipe({ variant })),
        className,
      )}
      type={type}
      disabled={disabled}
      ref={ref}
      tabIndex={inSlider ? getSliderTabIndex() : 0}
    >
      {children}
    </Component>
  );
};

Button.displayName = "Button";
